var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "actions is-centered" },
    [
      _c(
        "AppRadialMenu",
        {
          attrs: {
            size: 36,
            "item-size": 48,
            radius: 80,
            "angle-restriction": 45,
            rotate: -22
          }
        },
        [
          _c(
            "AppRadialMenuItem",
            {
              staticClass:
                "tooltip is-tooltip-info has-background-info has-text-white",
              attrs: { "data-tooltip": "Descargar XML" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "action-option",
                  on: {
                    click: function($event) {
                      return _vm.download("xml")
                    }
                  }
                },
                [
                  _c("BIcon", {
                    staticClass: "action-option-icon",
                    attrs: { icon: "cloud-download" }
                  }),
                  _c("span", { staticClass: "close-label" }, [
                    _vm._v("\n          xml\n        ")
                  ])
                ],
                1
              )
            ]
          ),
          _c(
            "AppRadialMenuItem",
            {
              staticClass:
                "tooltip is-tooltip-info has-background-info has-text-white",
              attrs: { "data-tooltip": "Descargar PDF" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "action-option",
                  on: {
                    click: function($event) {
                      return _vm.download("pdf")
                    }
                  }
                },
                [
                  _c("BIcon", {
                    staticClass: "action-option-icon",
                    attrs: { icon: "cloud-download" }
                  }),
                  _c("span", { staticClass: "close-label" }, [
                    _vm._v("\n          pdf\n        ")
                  ])
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }